<div *ngIf="loader" class="spinner">
  <nx-spinner nxSize="large"></nx-spinner>
</div>
<div *ngIf="!loader" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

  <nx-accordion>
    <nx-expansion-panel [expanded]="true">
        <nx-expansion-panel-header>
            <nx-expansion-panel-title
                >Wichtigste Attribute</nx-expansion-panel-title
            >
        </nx-expansion-panel-header>
      <div nxRow>
        <div nxCol="3">Vorgang ID</div>
        <div nxCol="2">
          <nx-formfield>
            <nx-dropdown [(ngModel)]="filter.filterMetadata!.coverProcessIdFilterOperation" nxValue="{{selected}}" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
              <nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield [ngClass]="{'error': !isInteger.coverProcessId}"><input nxInput  (ngModelChange)="validateInteger('coverProcessId', $event)" [(ngModel)]="filter.filterMetadata!.coverProcessId"/></nx-formfield>
         <div *ngIf="!isInteger.coverProcessId" class="error-message">
           {{WRONG_NUMERIC_MSG}}
         </div>
        </div>
      </div>
      <div nxRow>
        <div nxCol="3">Personennummer DN</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.policyHolderIdFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield [ngClass]="{'error': !isInteger.policyHolderId}"><input nxInput name="policyHolderId" (ngModelChange)="validateInteger('policyHolderId', $event)" [(ngModel)]="filter.filterMetadata!.policyHolderId"/></nx-formfield>
          <div *ngIf="!isInteger.policyHolderId" class="error-message">
            {{WRONG_NUMERIC_MSG}}
          </div>
       </div>
      </div>
      <div nxRow>
        <div nxCol="3">Personennummer AK</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.foreignCustomerIdFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield [ngClass]="{'error': !isInteger.foreignCustomerId}"><input nxInput name="foreignCustomerId" (ngModelChange)="validateInteger('foreignCustomerId', $event)" [(ngModel)]="filter.filterMetadata!.foreignCustomerId"/></nx-formfield>
          <div *ngIf="!isInteger.foreignCustomerId" class="error-message">
            {{WRONG_NUMERIC_MSG}}
          </div>
        </div>
      </div>
      <div nxRow>
        <div nxCol="3">Vertrag APG</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.contractNumberFilterOperation" placeholder="="><nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield [ngClass]="{'error': !isInteger.contractNumber}"><input nxInput name="contractNumber" (ngModelChange)="validateInteger('contractNumber', $event)" [(ngModel)]="filter.filterMetadata!.contractNumber"/></nx-formfield>
         <div *ngIf="!isInteger.contractNumber" class="error-message">
           {{WRONG_NUMERIC_MSG}}
         </div>
       </div>
      </div>

      <div nxRow>
        <div nxCol="3">Land</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.countryFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText"  nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
         <nx-formfield>
           <nx-dropdown [(ngModel)]="filter.filterMetadata!.country" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
             <nx-dropdown-item
               *ngFor="let country of countriesData"
               nxValue="{{country.key}}"
             >{{country.value}}</nx-dropdown-item>
           </nx-dropdown>
         </nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">Dokument Datum</div>
          <div nxCol="2">
            <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentDateFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesDateTime" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
          </div>
         <div nxCol="5">
           <div *ngIf="filter.filterMetadata!.documentDateFilterOperation !== 'BETWEEN' && filter.filterMetadata!.documentDateFilterOperation !== 'NOT_BETWEEN'">
             <nx-formfield>
               <input
                 nxDatefield
                 nxInput
                 [nxDatepicker]="documentDateDatepicker"
                 [(ngModel)]="filter.filterMetadata!.documentDate"
               />
               <nx-datepicker-toggle
                 [for]="documentDateDatepicker"
                 nxFormfieldSuffix
               ></nx-datepicker-toggle>
               <nx-datepicker #documentDateDatepicker></nx-datepicker>
             </nx-formfield>
           </div>
           <div nxRow *ngIf="filter.filterMetadata!.documentDateFilterOperation === 'BETWEEN' || filter.filterMetadata!.documentDateFilterOperation === 'NOT_BETWEEN'">
             <div nxCol="5">
               <nx-formfield>
                 <input
                   nxDatefield
                   nxInput
                   [nxDatepicker]="document2Datepicker"
                   [(ngModel)]="filter.filterMetadata!.documentDate"
                 />
                 <nx-datepicker-toggle
                   [for]="document2Datepicker"
                   nxFormfieldSuffix
                 ></nx-datepicker-toggle>
                 <nx-datepicker #document2Datepicker></nx-datepicker>
               </nx-formfield>
             </div>
             <div nxCol="2">
             </div>
             <div nxCol="5">
               <nx-formfield>
                 <input
                   nxDatefield
                   nxInput
                   [nxDatepicker]="documentEndDatepicker"
                   [(ngModel)]="filter.filterMetadata!.documentDateFilterOption"
                 />
                 <nx-datepicker-toggle
                   [for]="documentEndDatepicker"
                   nxFormfieldSuffix
                 ></nx-datepicker-toggle>
                 <nx-datepicker #documentEndDatepicker></nx-datepicker>
               </nx-formfield>
             </div>
           </div>
        </div>
      </div>
      <div nxRow>
        <div nxCol="3">Dokument Kategorie</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentCategoryFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
         <nx-formfield>
           <nx-dropdown [(ngModel)]="filter.filterMetadata!.documentCategory" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
             <nx-dropdown-item
               *ngFor="let documentCategory of documentCategoryData"
               nxValue="{{documentCategory.key}}"
             >{{documentCategory.value}}</nx-dropdown-item>
           </nx-dropdown>
         </nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">Dokument Typ</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentTypeFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
         <nx-formfield>
           <nx-dropdown [(ngModel)]="filter.filterMetadata!.documentType" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
             <nx-dropdown-item
               *ngFor="let documentType of documentTypeData"
               nxValue="{{documentType.key}}"
             >{{documentType.value}}</nx-dropdown-item>
           </nx-dropdown>
         </nx-formfield>
        </div>
      </div>
      <div nxRow>
        <div nxCol="3">Dokument Titel</div>
        <div nxCol="2">
          <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentTitleFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield><input nxInput name="documentTitle"  [(ngModel)]="filter.filterMetadata!.documentTitle"/></nx-formfield>
        </div>
      </div>
        <div nxRow>
          <div nxCol="3">Dokument bearbeitet</div>
          <div nxCol="2">
            <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentProcessedFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
          </div>
         <div nxCol="5">
            <nx-formfield>
             <nx-dropdown [(ngModel)]="filter.filterMetadata!.documentProcessed" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
               <nx-dropdown-item
                 *ngFor="let documentProcessed of documentProcessedData"
                 nxValue="{{documentProcessed.key}}"
               >{{documentProcessed.value}}</nx-dropdown-item>
             </nx-dropdown>
           </nx-formfield>
         </div>
        </div>

        <div nxRow>
          <div nxCol="3">Dokumenten Notiz</div>
          <div nxCol="2">
            <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentNotesFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
          </div>
         <div nxCol="5">
            <nx-formfield ><input nxInput name="documentNotes"  [(ngModel)]="filter.filterMetadata!.documentNotes"/></nx-formfield>
          </div>
        </div>

        <div nxRow>
          <div nxCol="3">Dokument Status</div>
          <div nxCol="2">
            <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentStatusFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
          </div>
         <div nxCol="5">
           <nx-formfield>
             <nx-dropdown [(ngModel)]="filter.filterMetadata!.documentStatus" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
               <nx-dropdown-item
                 *ngFor="let documentStatus of documentStatusData"
                 nxValue="{{documentStatus.key}}"
               >{{documentStatus.value}}</nx-dropdown-item>
             </nx-dropdown>
           </nx-formfield>
          </div>
        </div>

        <div nxRow>
          <div nxCol="3">Dokument Status Timestamp</div>
          <div nxCol="2">
            <nx-formfield ><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentStatusTimestampFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
          </div>
         <div nxCol="5">
            <nx-formfield><input nxInput name="documentStatusTimestamp"  [(ngModel)]="filter.filterMetadata!.documentStatusTimestamp"/></nx-formfield>
          </div>
        </div>
    </nx-expansion-panel>
    <nx-expansion-panel>
      <nx-expansion-panel-header>
          <nx-expansion-panel-title
              >Weitere Attribute</nx-expansion-panel-title
          >
      </nx-expansion-panel-header>

      <div nxRow>
        <div nxCol="3">E-Mail Empfänger</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.emailReceiptFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield><input nxInput name="emailReceipt"  [(ngModel)]="filter.filterMetadata!.emailReceipt"/></nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">E-Mail Kopie an</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.emailCopyToFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield><input nxInput name="emailCopyTo"  [(ngModel)]="filter.filterMetadata!.emailCopyTo"/></nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">E-Mail Them</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.emailSubjectFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield><input nxInput name="emailSubject"  [(ngModel)]="filter.filterMetadata!.emailSubject"/></nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">E-Mail Zeitstempel</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.emailSendTimestampFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield><input nxInput name="emailSendTimestamp"  [(ngModel)]="filter.filterMetadata!.emailSendTimestamp"/></nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">Rechnung Nummer</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.invoiceNumberFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
          <nx-formfield><input nxInput name="invoiceNumber"  [(ngModel)]="filter.filterMetadata!.invoiceNumber"/></nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">Eingang Ausgang</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.inOutFlagFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
        <div nxCol="5">
          <nx-formfield>
            <nx-dropdown [(ngModel)]="filter.filterMetadata!.inOutFlag">
              <nx-dropdown-item
                *ngFor="let inOutFlag of inOutFlagData"
                nxValue="{{inOutFlag.key}}"
              >{{inOutFlag.value}}</nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
        </div>
      </div>

      <div nxRow>
        <div nxCol="3">Dokument Kanal</div>
        <div nxCol="2">
          <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentChannelFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
        </div>
       <div nxCol="5">
         <nx-formfield>
           <nx-dropdown [(ngModel)]="filter.filterMetadata!.documentChannel" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
             <nx-dropdown-item
               *ngFor="let documentChannel of documentChannelData"
               nxValue="{{documentChannel.key}}"
             >{{documentChannel.value}}</nx-dropdown-item>
           </nx-dropdown>
         </nx-formfield>
        </div>
      </div>


    </nx-expansion-panel>
  <nx-expansion-panel>
    <nx-expansion-panel-header>
        <nx-expansion-panel-title
            >Selten gebrauchte Attribute</nx-expansion-panel-title
        >
    </nx-expansion-panel-header>

    <div nxRow>
      <div nxCol="3">Dokument Anzahl Seiten</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentPagesNoFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
     <div nxCol="5">
        <nx-formfield><input nxInput name="documentPagesNo"  [(ngModel)]="filter.filterMetadata!.documentPagesNo"/></nx-formfield>
      </div>
    </div>

    <div nxRow>
      <div nxCol="3">Vertraulichkeitsstufe</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.confidentialityLevelFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
     <div nxCol="5">
         <nx-formfield>
           <nx-dropdown [(ngModel)]="filter.filterMetadata!.confidentialityLevel" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
             <nx-dropdown-item
               *ngFor="let confidentialityLevel of confidentialityLevelData"
               nxValue="{{confidentialityLevel.key}}"
             >{{confidentialityLevel.value}}</nx-dropdown-item>
           </nx-dropdown>
         </nx-formfield>
     </div>
    </div>

    <div nxRow>
      <div nxCol="3">Datenschutz</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.dataProtectionFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
      <div nxCol="5">
        <nx-formfield>
          <nx-dropdown [(ngModel)]="filter.filterMetadata!.dataProtection" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
            <nx-dropdown-item
              *ngFor="let dataProtection of dataProtectionData"
              nxValue="{{dataProtection.key}}"
            >{{dataProtection.value}}</nx-dropdown-item>
          </nx-dropdown>
        </nx-formfield>
      </div>
    </div>

    <div nxRow>
      <div nxCol="3">Barcode</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.barcodeFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
     <div nxCol="5">
        <nx-formfield><input nxInput name="barcode"  [(ngModel)]="filter.filterMetadata!.barcode"/></nx-formfield>
      </div>
    </div>

    <div nxRow>
      <div nxCol="3">Barcode Gruppe</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.barcodeGroupFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
     <div nxCol="5">
        <nx-formfield><input nxInput name="barcodeGroup"  [(ngModel)]="filter.filterMetadata!.barcodeGroup"/></nx-formfield>
      </div>
    </div>

    <div nxRow>
      <div nxCol="3">Papierarchiv Referenz</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.paperArchiveReferenceFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
     <div nxCol="5">
        <nx-formfield><input nxInput name="paperArchiveReference"  [(ngModel)]="filter.filterMetadata!.paperArchiveReference"/></nx-formfield>
      </div>
    </div>

    <div nxRow>
      <div nxCol="3">Papierarchiv Referenz 2</div>
      <div nxCol="2">
        <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.paperArchiveReference2FilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
      </div>
     <div nxCol="5">
        <nx-formfield><input nxInput name="paperArchiveReference2"  [(ngModel)]="filter.filterMetadata!.paperArchiveReference2"/></nx-formfield>
      </div>
    </div>


</nx-expansion-panel>
<nx-expansion-panel>
  <nx-expansion-panel-header>
      <nx-expansion-panel-title
          >Systemattribute</nx-expansion-panel-title
      >
  </nx-expansion-panel-header>

  <div nxRow>
    <div nxCol="3">Änderungs User</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.changeUserFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="changeUser"  [(ngModel)]="filter.filterMetadata!.changeUser"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Liefer System</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.deliverySystemFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
     <nx-formfield>
       <nx-dropdown [(ngModel)]="filter.filterMetadata!.deliverySystem" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()">
         <nx-dropdown-item
           *ngFor="let deliverySystem of deliverySystemData"
           nxValue="{{deliverySystem.key}}"
         >{{deliverySystem.value}}</nx-dropdown-item>
       </nx-dropdown>
     </nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Mime Type</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentMimeTypeFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="documentMimeType"  [(ngModel)]="filter.filterMetadata!.documentMimeType"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Lade Datum</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.loadDateFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesDateTime" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
    <div nxCol="5">
      <div *ngIf="filter.filterMetadata!.loadDateFilterOperation !== 'BETWEEN' && filter.filterMetadata!.loadDateFilterOperation !== 'NOT_BETWEEN'">
        <nx-formfield>
          <input
            nxDatefield
            nxInput
            [nxDatepicker]="loadDatepicker"
            [(ngModel)]="filter.filterMetadata!.loadDate"
          />
          <nx-datepicker-toggle
            [for]="loadDatepicker"
            nxFormfieldSuffix
          ></nx-datepicker-toggle>
          <nx-datepicker #loadDatepicker></nx-datepicker>
        </nx-formfield>
      </div>
      <div nxRow *ngIf="filter.filterMetadata!.loadDateFilterOperation === 'BETWEEN' || filter.filterMetadata!.loadDateFilterOperation === 'NOT_BETWEEN'">
        <div nxCol="5">
          <nx-formfield>
            <input
              nxDatefield
              nxInput
              [nxDatepicker]="loadDateStartpicker"
              [(ngModel)]="filter.filterMetadata!.loadDate"
            />
            <nx-datepicker-toggle
              [for]="loadDateStartpicker"
              nxFormfieldSuffix
            ></nx-datepicker-toggle>
            <nx-datepicker #loadDateStartpicker></nx-datepicker>
          </nx-formfield>
        </div>
        <div nxCol="2">
        </div>
        <div nxCol="5">
          <nx-formfield>
            <input
              nxDatefield
              nxInput
              [nxDatepicker]="loadEndDatepicker"
              [(ngModel)]="filter.filterMetadata!.loadDateFilterOption"
            />
            <nx-datepicker-toggle
              [for]="loadEndDatepicker"
              nxFormfieldSuffix
            ></nx-datepicker-toggle>
            <nx-datepicker #loadEndDatepicker></nx-datepicker>
          </nx-formfield>
        </div>
      </div>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Lade Zeit</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.loadTimeFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="loadTime"  [(ngModel)]="filter.filterMetadata!.loadTime"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Lade User</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.loadUserFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="loadUser"  [(ngModel)]="filter.filterMetadata!.loadUser"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Fehler Text</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.documentErrorFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="documentError"  [(ngModel)]="filter.filterMetadata!.documentError"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Job ID</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.jobIdFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="jobId"  [(ngModel)]="filter.filterMetadata!.jobId"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Lösch Datum</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.retentionDateFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesDateTime" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
    <div nxCol="5">
      <div *ngIf="filter.filterMetadata!.retentionDateFilterOperation !== 'BETWEEN' && filter.filterMetadata!.retentionDateFilterOperation !== 'NOT_BETWEEN'">
        <nx-formfield>
          <input
            nxDatefield
            nxInput
            [nxDatepicker]="retentionDatepicker"
            [(ngModel)]="filter.filterMetadata!.retentionDate"
          />
          <nx-datepicker-toggle
            [for]="retentionDatepicker"
            nxFormfieldSuffix
          ></nx-datepicker-toggle>
          <nx-datepicker #retentionDatepicker></nx-datepicker>
        </nx-formfield>
      </div>
      <div nxRow *ngIf="filter.filterMetadata!.retentionDateFilterOperation === 'BETWEEN' || filter.filterMetadata!.retentionDateFilterOperation === 'NOT_BETWEEN'">
        <div nxCol="5">
          <nx-formfield>
            <input
              nxDatefield
              nxInput
              [nxDatepicker]="retentionDateStartDatepicker"
              [(ngModel)]="filter.filterMetadata!.retentionDate"
            />
            <nx-datepicker-toggle
              [for]="retentionDateStartDatepicker"
              nxFormfieldSuffix
            ></nx-datepicker-toggle>
            <nx-datepicker #retentionDateStartDatepicker></nx-datepicker>
          </nx-formfield>
        </div>
        <div nxCol="2">
        </div>
        <div nxCol="5">
          <nx-formfield>
            <input
              nxDatefield
              nxInput
              [nxDatepicker]="retentionDateEndDatepicker"
              [(ngModel)]="filter.filterMetadata!.retentionDateFilterOption"
            />
            <nx-datepicker-toggle
              [for]="retentionDateEndDatepicker"
              nxFormfieldSuffix
            ></nx-datepicker-toggle>
            <nx-datepicker #retentionDateEndDatepicker></nx-datepicker>
          </nx-formfield>
        </div>
      </div>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">DUI</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.duiFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="dui"  [(ngModel)]="filter.filterMetadata!.dui"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">S3 Pfad</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.s3PathFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesText" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="s3Path"  [(ngModel)]="filter.filterMetadata!.s3Path"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">EDMID</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.edmIdFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="edmId"  [(ngModel)]="filter.filterMetadata!.edmId"/></nx-formfield>
    </div>
  </div>

  <div nxRow>
    <div nxCol="3">Dokument ID</div>
    <div nxCol="2">
      <nx-formfield><nx-dropdown [(ngModel)]="filter.filterMetadata!.originalIdFilterOperation" placeholder="=" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"><nx-dropdown-item *ngFor="let filterOperator of operationCodesNumeric" nxValue="{{filterOperator.key}}">{{filterOperator.value}}</nx-dropdown-item></nx-dropdown></nx-formfield>
    </div>
   <div nxCol="5">
      <nx-formfield><input nxInput name="originalId"  [(ngModel)]="filter.filterMetadata!.originalId"/></nx-formfield>
    </div>
  </div>

</nx-expansion-panel>
</nx-accordion>

<div nxRow class="position">
  <div nxCol="3">
  </div>

  <div nxCol="3">
    <button [disabled]="!(isInteger.coverProcessId && isInteger.policyHolderId && isInteger.foreignCustomerId && isInteger.contractNumber)"
            nxButton="primary small" (click)="search()" class="my-search-button" type="button">Suchen</button>
  </div>
  <div nxCol="1">
  </div>
  <div nxCol="3">
      <button nxButton="primary small" (click)="resetForm()" class="my-search-button"  type="button">Zurücksetzen</button>
  </div>
</div>
</div>
